import React from 'react';
import BasicLayout from 'layout/Basic';
import getConfig from 'next/config';
import { NextSeo } from 'next-seo';
import { convertProps } from 'lib/parseAPIResponse';
import CompanyDetails from 'containers/Companies/Details';

interface Props extends Company {
    ads: PageAds;
}

export const CompanyPage = (props: Props): React.JSX.Element => {
    const { url } = getConfig().publicRuntimeConfig;
    const description = props.about?.replace(/<[^>]*>?/gm, '');

    return (
        <BasicLayout ads={props.ads}>
            <NextSeo
                title={props.name}
                description={description}
                canonical={`${url}/katalog-firm/${props.seoSlug}`}
                openGraph={{
                    title: props.name,
                    description: description,
                    url: `${url}/katalog-firm/${props.seoSlug}`,
                    images: [
                        {
                            url: props.logo,
                            alt: props.name
                        }
                    ]
                }}
            />
            <CompanyDetails {...props} />
        </BasicLayout>
    );
};

export async function getServerSideProps({ params, query }) {
    const { slug } = params;
    const { apiUrl } = getConfig().publicRuntimeConfig;
    const queryParams = query._previewKey ? `?_previewKey=${query._previewKey}` : '';
    const path = `/public/api/companies/${slug}`;
    const url = apiUrl + path;
    return Promise.all([
        fetch(url + queryParams),
        fetch(`${apiUrl}/public/api/naszadsik?path=companies/${slug}`)
    ]).then(async ([res1, res2]) => {
        const data = await res1.json();
        if (data.code === 404) {
            return {
                notFound: true
            };
        }
        const ads = await res2.json();

        return {
            props: {
                ...convertProps(ads),
                ...convertProps(data)
            }
        };
    });
}

export default CompanyPage;
